import { left } from "@popperjs/core";
import $ from "jquery";

function init() {
    $(".info-container").on("mouseenter", function (e) {
        showTooltip(this);
    });

    $(".info-container").on("click", function (e) {
        showTooltip(this);
    });
}

export default init();

function showTooltip(trigger) {
    const tooltip = $(trigger).find(".info-tooltip");
    const offset = $(trigger).offset();

    tooltip.appendTo(".main-outercon");

    const height = $(tooltip).outerHeight();
    const width = $(tooltip).outerWidth();

    // show tooltip
    const position = getPosition({ top: offset.top - $(trigger).outerHeight(), left: offset.left + $(trigger).outerWidth() }, width, height);

    tooltip.css(position);
    tooltip.fadeIn(300);

    // hide after 100ms
    $(trigger).on("mouseleave", function () {
        setTimeout(() => {
            hideTooltip(tooltip, trigger);
        }, 300);
    });

    $(document).on("click", function (e) {
        if (!$(trigger).is(e.target) && $(trigger).has(e.target).length === 0) {
            hideTooltip(tooltip, trigger, true);
            $(document).off("click");
        }
    });

    $(window).on("scroll", function () {
        hideTooltip(tooltip, trigger, true);
        $(window).off("scroll");
    });
}

function getPosition(offset, width, height) {
    let position = {
        top: `${offset.top}px`,
        left: `${offset.left}px`,
    };

    const windowWidth = $(window).width();
    const windowBottom = $(window).scrollTop() + $(window).height();
    const elementBottom = offset.top + height;

    if (windowWidth >= 768) {
        if (elementBottom > windowBottom) {
            const diff = elementBottom - windowBottom + 20;
            const top = offset.top - diff;

            position.top = `${top}px`;
        }
    } else {
        const windowTop = $(window).scrollTop();
        const top = (windowBottom + windowTop) / 2 - height / 2;
        const left = windowWidth / 2 - width / 2;
        position.top = `${top}px`;
        position.left = `${left}px`;
    }

    return position;
}

function hideTooltip(tooltip, element, hard = false) {
    // if mouse is over tooltip, do not hide
    if (tooltip.is(":hover") && !hard) {
        tooltip.on("mouseleave", function () {
            hideTooltip(tooltip, element);
            tooltip.off("mouseleave");
        });

        return;
    }

    tooltip.fadeOut(300, () => {
        tooltip.appendTo(element);
        tooltip.removeAttr("style");
    });

    $(element).off("mouseleave");
}
